@let formGroupWebsite = userService.formGroupWebsite;
<form [formGroup]="formGroupWebsite">
  @if ((formGroupWebsite | isNil: false) && (formGroupWebsite | isNil: false)) {
    <mat-card appearance="outlined">
      <div class="form-column-left">
        <fa-icon
          [icon]="['far', 'globe']"
          size="4x"
          style="color: grey"></fa-icon>
      </div>
      <div class="form-column-right">
        <!--
        <mat-checkbox formControlName="active" #onlineAccess>{{ 'PRODUCT.USERADMIN.WEBSITE.ACCESSTO' | translate }}
          <b>{{ 'PRODUCT.USERADMIN.WEBSITE.URL' | translate }}</b> erlauben
        </mat-checkbox>
        -->

        <table>
          <tr>
            <td>
              <mat-checkbox
                formControlName="active"
                #onlineAccess
                (change)="onClickSectionCheckbox('online', $event)">
                {{ 'PRODUCT.USERADMIN.WEBSITE.ACCESSTO' | translate }}
                <b>{{ 'PRODUCT.USERADMIN.WEBSITE.URL' | translate }}</b>
                erlauben </mat-checkbox
              >&nbsp;
            </td>
            @let contingentsValue = contingents();
            @let usedContingentsValue = userService.usedContingents();
            <td>
              <fa-icon
                [icon]="['far', 'asterisk']"
                [ngStyle]="{
                  color:
                    usedContingentsValue['online'] < contingentsValue['online']
                      ? 'green'
                      : 'red',
                }"></fa-icon
              >&nbsp;
            </td>
            <td>
              <table class="upload-format-table">
                <tr>
                  <td>
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.TEXT1' | translate }}
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.online' | translate }}
                    :
                  </td>
                  <td>{{ contingentsValue['online'] }}</td>
                </tr>
                <tr>
                  <td>
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.TEXT2' | translate }}:
                  </td>
                  <td>{{ usedContingentsValue['online'] }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <br />
        @if (onlineAccess.checked) {
          <mat-form-field>
            <mat-label
              >{{ 'PRODUCT.USERADMIN.CONTRACTTIMERANGE' | translate }}
              {{ 'PRODUCT.USERADMIN.FROM' | translate }}</mat-label
            >
            <input
              matInput
              [matDatepicker]="picker4"
              formControlName="dateFrom" />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker4"></mat-datepicker-toggle>
            <mat-datepicker #picker4></mat-datepicker>
            <mat-error wmMatErrorMessages></mat-error>
          </mat-form-field>
          &nbsp;
          <mat-checkbox formControlName="endless" #onlineEndless>{{
            'PRODUCT.USERADMIN.ENDLESSTIME' | translate
          }}</mat-checkbox>
          @if (!onlineEndless.checked) {
            <br />
            <mat-form-field>
              <mat-label
                >{{ 'PRODUCT.USERADMIN.CONTRACTTIMERANGE' | translate }}
                {{ 'PRODUCT.USERADMIN.TO' | translate }}</mat-label
              >
              <input
                matInput
                [matDatepicker]="picker5"
                formControlName="dateTo" />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker5"></mat-datepicker-toggle>
              <mat-datepicker #picker5></mat-datepicker>
              <mat-error wmMatErrorMessages></mat-error>
            </mat-form-field>
            &nbsp;
          }
        }
      </div>
      <div class="clear"></div>
    </mat-card>
  }
  <br />

  @if (
    (formGroupWebsite | isNil: false) &&
    formGroupWebsite.controls['active'] &&
    formGroupWebsite.controls['active'].value
  ) {
    @let areAllProductsSelectedValue = userService.areAllProductsSelected();

    <mat-card appearance="outlined">
      <p>
        <b>{{ 'PRODUCT.USERADMIN.PRODUCTS.TITLE' | translate }}</b>
      </p>
      <p>{{ 'PRODUCT.USERADMIN.WEBSITE.INFO' | translate }}</p>
      <mat-checkbox
        #allProductsOnline
        [checked]="areAllProductsSelectedValue.online"
        (change)="onClickAllProducts('online', $event)"
        >{{ 'PRODUCT.USERADMIN.WEBSITE.FULLACCESS' | translate }}
      </mat-checkbox>
      <br />
      <!--Product Access Selection (Step Website) -->
      @if (!allProductsOnline.checked) {
        @let productListValue = productList();
        @let egpTypesValue = egpTypes();

        @let userServiceUserDataValue = userService.userData();
        <ng-container
          *ngTemplateOutlet="
            buttonsTemplate();
            context: { section: 'online' }
          "></ng-container>
        <mat-list>
          <!--epp-->
          @if (productListValue.epp | isNotEmptyObject) {
            <div mat-subheader>
              <fa-icon [icon]="['far', 'clouds-sun']" size="lg"></fa-icon>
              &nbsp; {{ 'PRODUCT.EPP.TITLE' | translate }}
            </div>

            <mat-accordion
              #accordionEppOnline="matAccordion"
              multi
              class="accordion-headers-align">
              <mat-expansion-panel
                (expandedChange)="onExpandedChanged('online')">
                @let eppProductsInListValue =
                  productListValue | eppProductsInList;
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @let hasUserEppProduct =
                      'online'
                        | hasUserEppProduct
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                          : productListValue;
                    @if (hasUserEppProduct) {
                      <span>
                        <fa-icon
                          [icon]="['far', 'check']"
                          style="color: green"></fa-icon>
                      </span>
                    } @else {
                      <span>
                        <fa-icon
                          [icon]="['far', 'times']"
                          style="color: red"></fa-icon>
                      </span>
                    }
                    &nbsp; EPP
                    <!--
                            &nbsp;{{ 'PRODUCT.EPP.PARAMETERSET.SETS.' + parameterset | translate }} -
                            {{ resolution.days }} {{ 'PRODUCT.EPP.RESOLUTION.DAYS' | translate }}
                            ({{ 'PRODUCT.EPP.RESOLUTION.HOURLY.' + resolution.hourly | translate }})
                            -->
                  </mat-panel-title>
                  <mat-panel-description>
                    {{
                      'online'
                        | countUserProductStations
                          : areAllProductsSelectedValue
                          : 'epp'
                          : {
                              epp: true,
                            }
                          : productListValue
                          : userServiceUserDataValue
                    }}
                    / {{ eppProductsInListValue.length }}
                    {{ 'PRODUCT.USERADMIN.PLACES' | translate }}
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <table class="product-detail-table" width="100%">
                  <tr>
                    <th>{{ 'PRODUCT.USERADMIN.PLACE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                  </tr>
                  @for (
                    product of eppProductsInListValue;
                    track $index;
                    let i = $index
                  ) {
                    <tr>
                      <td align="center">
                        <mat-checkbox
                          #check
                          [checked]="
                            userServiceUserDataValue
                              | hasUserStation
                                : product
                                : 'online'
                                : areAllProductsSelectedValue
                          "
                          (change)="
                            onUserStationChange($event, product, 'online')
                          "></mat-checkbox>
                      </td>
                      <td>
                        {{ product['station']['overwriteStationName'] }}
                      </td>
                      <td>
                        @if (product['outOfSeason']) {
                          <fa-icon
                            [icon]="['far', 'times']"
                            style="color: red"></fa-icon>
                        } @else {
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        }
                      </td>
                      <td>
                        {{ product['productData']['saison']['start']['day'] }}
                        .{{
                          product['productData']['saison']['start']['month']
                        }}. -
                        {{ product['productData']['saison']['end']['day'] }}
                        .{{ product['productData']['saison']['end']['month'] }}.
                      </td>
                    </tr>
                  }
                </table>
              </mat-expansion-panel>
            </mat-accordion>
          }

          @if (false && productListValue.eop | isNotEmptyObject) {
            <!--eop product -->
            <div mat-subheader>
              <fa-icon [icon]="['far', 'table']" size="lg"></fa-icon>&nbsp;
              {{ 'PRODUCT.EOP.TITLE' | translate }}
            </div>
            <mat-accordion
              #accordionEopOnline="matAccordion"
              multi
              class="accordion-headers-align">
              @for (eopType of eopTypes(); track $index) {
                @if (productListValue.eop.hasOwnProperty(eopType)) {
                  <mat-expansion-panel
                    (expandedChange)="onExpandedChanged('online')">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        @let hasUserEopProduct =
                          'online'
                            | hasUserEopProduct
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                              : productListValue
                              : eopType;
                        @if (hasUserEopProduct) {
                          <span>
                            <fa-icon
                              [icon]="['far', 'check']"
                              style="color: green"></fa-icon>
                          </span>
                        } @else {
                          <span>
                            <fa-icon
                              [icon]="['far', 'times']"
                              style="color: red"></fa-icon>
                          </span>
                        }
                        &nbsp;{{ 'PRODUCT.EOP.TYPE.' + eopType | translate }}
                      </mat-panel-title>
                      <mat-panel-description>
                        {{
                          'online'
                            | countUserProductStations
                              : areAllProductsSelectedValue
                              : 'eop'
                              : {
                                  productType: eopType,
                                }
                              : productListValue
                              : userServiceUserDataValue
                        }}
                        / {{ productListValue.eop[eopType].length }}
                        {{ 'PRODUCT.USERADMIN.PLACES' | translate }}
                      </mat-panel-description>
                    </mat-expansion-panel-header>

                    <table class="product-detail-table" width="100%">
                      <tr>
                        <th align="center">
                          {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                        </th>
                        <th>{{ 'PRODUCT.USERADMIN.PLACE' | translate }}</th>
                        <th>
                          {{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}
                        </th>
                        <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                      </tr>
                      @for (
                        product of productListValue.eop[eopType];
                        track $index;
                        let i = $index
                      ) {
                        <tr>
                          <td align="center">
                            <mat-checkbox
                              [checked]="
                                userServiceUserDataValue
                                  | hasUserStation
                                    : product
                                    : 'online'
                                    : areAllProductsSelectedValue
                              "
                              (change)="
                                onUserStationChange($event, product, 'online')
                              "></mat-checkbox>
                          </td>
                          <td>
                            {{ product['station']['overwriteStationName'] }}
                          </td>
                          <td>
                            @if (product['outOfSeason']) {
                              <fa-icon
                                [icon]="['far', 'times']"
                                style="color: red"></fa-icon>
                            } @else {
                              <fa-icon
                                [icon]="['far', 'check']"
                                style="color: green"></fa-icon>
                            }
                          </td>
                          <td>
                            {{
                              product['productData']['saison']['start']['day']
                            }}
                            .{{
                              product['productData']['saison']['start'][
                                'month'
                              ]
                            }}. -
                            {{ product['productData']['saison']['end']['day'] }}
                            .{{
                              product['productData']['saison']['end']['month']
                            }}.
                          </td>
                        </tr>
                      }
                    </table>
                  </mat-expansion-panel>
                }
              }
            </mat-accordion>
          }
          <!--egp product (winter+summer)-->
          @if (
            productListValue.egp.length + productListValue.egpsummer.length > 0
          ) {
            <div mat-subheader>
              <fa-icon [icon]="['far', 'pen']" size="lg"></fa-icon>
              &nbsp;{{ 'PRODUCT.EGP.TITLE' | translate }}
            </div>
          }

          <mat-accordion
            #accordionEgpOnline="matAccordion"
            multi
            class="accordion-headers-align">
            @for (productType of ['egp', 'egpsummer']; track $index) {
              @if (productListValue[productType].length > 0) {
                <mat-expansion-panel
                  (expandedChange)="onExpandedChanged('online')">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @if (
                        'online'
                          | hasUserProductType
                            : productType
                            : productListValue
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                      ) {
                        <span>
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        </span>
                      } @else {
                        <span>
                          <fa-icon
                            [icon]="['far', 'times']"
                            [ngStyle]="{ color: 'red' }"></fa-icon>
                        </span>
                      }
                      &nbsp;
                      {{ 'SAISON.' + egpTypesValue[productType] | translate }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{
                        'online'
                          | countUserProducts
                            : productType
                            : productListValue
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                      }}
                      /
                      {{ productListValue[productType].length }}
                      {{ 'PRODUCT.USERADMIN.REGIONS' | translate }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <table class="product-detail-table" width="100%">
                    <tr>
                      <th align="center">
                        {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                      </th>
                      <th>{{ 'PRODUCT.USERADMIN.REGION' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                    </tr>
                    @for (
                      product of productListValue[productType];
                      track $index;
                      let i = $index
                    ) {
                      <tr>
                        <td align="center">
                          <mat-checkbox
                            [checked]="
                              'online'
                                | hasUserProduct
                                  : areAllProductsSelectedValue
                                  : userServiceUserDataValue
                                  : product['id']
                            "
                            (change)="
                              onUserProductChange($event, product, 'online')
                            "></mat-checkbox>
                        </td>
                        <td>{{ product['area'] }}</td>
                        <td>
                          @if (product['outOfSeason']) {
                            <fa-icon
                              [icon]="['far', 'times']"
                              style="color: red"></fa-icon>
                          } @else {
                            <fa-icon
                              [icon]="['far', 'check']"
                              style="color: green"></fa-icon>
                          }
                        </td>
                        <td>
                          {{ product['productData']['saison']['start']['day'] }}
                          .{{
                            product['productData']['saison']['start']['month']
                          }}. -
                          {{ product['productData']['saison']['end']['day'] }}
                          .{{
                            product['productData']['saison']['end']['month']
                          }}.
                        </td>
                      </tr>
                    }
                  </table>
                </mat-expansion-panel>
              }
            }
          </mat-accordion>
          <!--egw product (winter+summer)-->
          @if (
            productListValue.egw.length + productListValue.egwsummer.length > 0
          ) {
            <div mat-subheader>
              <fa-icon
                [icon]="['far', 'exclamation-triangle']"
                size="lg"></fa-icon>
              &nbsp; {{ 'PRODUCT.WARNING.TITLE' | translate }}
            </div>
          }
          <mat-accordion
            #accordionEgwOnline="matAccordion"
            multi
            class="accordion-headers-align">
            @for (productType of ['egw']; track $index) {
              @if (productListValue[productType].length > 0) {
                <mat-expansion-panel
                  (expandedChange)="onExpandedChanged('online')">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @if (
                        'online'
                          | hasUserProductType
                            : productType
                            : productListValue
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                      ) {
                        <span>
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        </span>
                      } @else {
                        <span>
                          <fa-icon
                            [icon]="['far', 'times']"
                            style="color: red"></fa-icon>
                        </span>
                      }
                      &nbsp;
                      {{ 'SAISON.' + egpTypesValue[productType] | translate }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{
                        'online'
                          | countUserProducts
                            : productType
                            : productListValue
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                      }}
                      /
                      {{ productListValue.egw.length }}
                      {{ 'PRODUCT.USERADMIN.REGIONS' | translate }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <table class="product-detail-table" width="100%">
                    <tr>
                      <th align="center">
                        {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                      </th>
                      <th>{{ 'PRODUCT.USERADMIN.REGION' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                    </tr>
                    @for (
                      product of productListValue.egw;
                      track $index;
                      let i = $index
                    ) {
                      <tr>
                        <td align="center">
                          <mat-checkbox
                            [checked]="
                              'online'
                                | hasUserProduct
                                  : areAllProductsSelectedValue
                                  : userServiceUserDataValue
                                  : product['id']
                            "
                            (change)="
                              onUserProductChange($event, product, 'online')
                            "></mat-checkbox>
                        </td>
                        <td>{{ product['area'] }}</td>
                        <td>
                          @if (product['outOfSeason']) {
                            <fa-icon
                              [icon]="['far', 'times']"
                              style="color: red"></fa-icon>
                          } @else {
                            <fa-icon
                              [icon]="['far', 'check']"
                              style="color: green"></fa-icon>
                          }
                        </td>
                        <td>
                          {{ product['productData']['saison']['start']['day'] }}
                          .{{
                            product['productData']['saison']['start']['month']
                          }}. -
                          {{ product['productData']['saison']['end']['day'] }}
                          .{{
                            product['productData']['saison']['end']['month']
                          }}.
                        </td>
                      </tr>
                    }
                  </table>
                </mat-expansion-panel>
              }
            }

            @for (productType of ['egwsummer']; track $index) {
              @if (productListValue[productType].length > 0) {
                <mat-expansion-panel
                  (expandedChange)="onExpandedChanged('online')">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @if (
                        'online'
                          | hasUserProductType
                            : productType
                            : productListValue
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                      ) {
                        <span>
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        </span>
                      } @else {
                        <span>
                          <fa-icon
                            [icon]="['far', 'times']"
                            style="color: red"></fa-icon>
                        </span>
                      }
                      &nbsp;
                      {{ 'SAISON.' + egpTypesValue[productType] | translate }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{
                        'online'
                          | countUserProducts
                            : productType
                            : productListValue
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                      }}
                      /
                      {{ productListValue.egwsummer.length }}
                      {{ 'PRODUCT.USERADMIN.WARNPLACES' | translate }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <table class="product-detail-table" width="100%">
                    <tr>
                      <th align="center">
                        {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                      </th>
                      <th>{{ 'PRODUCT.USERADMIN.WARNPLACE' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.WARNTYPES' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                    </tr>
                    @for (
                      product of productListValue.egwsummer;
                      track $index;
                      let i = $index
                    ) {
                      <tr>
                        <td align="center">
                          <mat-checkbox
                            [checked]="
                              'online'
                                | hasUserProduct
                                  : areAllProductsSelectedValue
                                  : userServiceUserDataValue
                                  : product['id']
                            "
                            (change)="
                              onUserProductChange($event, product, 'online')
                            "></mat-checkbox>
                        </td>
                        <td>{{ product['area'] }}</td>
                        <td>
                          @if (product['productData']['info']) {
                            <span>
                              {{ 'PRODUCT.WARNING.TYPE.VORAB' | translate }}
                              (E-Mail)<br />
                            </span>
                          }
                          @if (product['productData']['nowcast']) {
                            <span
                              >{{ 'METPARA_MEDIUM.THUNDERSTORM' | translate }}
                              <br
                            /></span>
                          }
                          @if (product['productData']['heavyRainWarning']) {
                            <span
                              >{{ 'METPARA_SHORT.HEAVY_RAIN' | translate }} <br
                            /></span>
                          }
                          @if (product['productData']['precipitationWarning']) {
                            <span
                              >{{
                                'PRODUCT.EGP-SUMMER.RISKBOX.DRAIN' | translate
                              }}
                              <br
                            /></span>
                          }
                          @if (product['productData']['windWarning']) {
                            <span
                              >{{
                                'PRODUCT.EGP-SUMMER.RISKBOX.STORM' | translate
                              }}
                              <br
                            /></span>
                          }
                        </td>
                        <td>
                          @if (product['outOfSeason']) {
                            <fa-icon
                              [icon]="['far', 'times']"
                              style="color: red"></fa-icon>
                          } @else {
                            <fa-icon
                              [icon]="['far', 'check']"
                              style="color: green"></fa-icon>
                          }
                        </td>
                        <td>
                          {{ product['productData']['saison']['start']['day'] }}
                          .{{
                            product['productData']['saison']['start']['month']
                          }}. -
                          {{ product['productData']['saison']['end']['day'] }}
                          .{{
                            product['productData']['saison']['end']['month']
                          }}.
                        </td>
                      </tr>
                    }
                  </table>
                </mat-expansion-panel>
              }
            }
          </mat-accordion>
          <!--gma product-->
          @if (
            productListValue.smw.gma.length +
              productListValue.smw.synop.length >
            0
          ) {
            <div mat-subheader>
              <fa-icon [icon]="['far', 'analytics']" size="lg"></fa-icon>
              &nbsp; {{ 'PRODUCT.SMW.TITLE' | translate }}
            </div>
          }
          <mat-accordion
            #accordionSmwOnline="matAccordion"
            multi
            class="accordion-headers-align">
            @for (stationType of ['gma', 'synop']; track $index) {
              @if (productListValue.smw[stationType].length > 0) {
                <mat-expansion-panel
                  (expandedChange)="onExpandedChanged('online')">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @let hasUserSmwProduct =
                        'online'
                          | hasUserSmwProduct
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                            : productListValue
                            : stationType;
                      @if (hasUserSmwProduct) {
                        <span>
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        </span>
                      } @else {
                        <span>
                          <fa-icon
                            [icon]="['far', 'times']"
                            [ngStyle]="{ color: 'red' }"></fa-icon>
                        </span>
                      }
                      &nbsp;
                      {{
                        'PRODUCT.SMW.STATION.TYPE.' + (stationType | uppercase)
                          | translate
                      }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{
                        'online'
                          | countUserProductStations
                            : areAllProductsSelectedValue
                            : 'smw'
                            : {
                                productType: stationType,
                              }
                            : productListValue
                            : userServiceUserDataValue
                      }}
                      / {{ productListValue.smw[stationType].length }}
                      {{ 'PRODUCT.USERADMIN.STATIONS' | translate }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <table class="product-detail-table" width="100%">
                    <tr>
                      <th align="center">
                        {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                      </th>
                      <th>{{ 'PRODUCT.USERADMIN.STATION' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                    </tr>
                    @for (
                      product of productListValue.smw[stationType];
                      track $index;
                      let i = $index
                    ) {
                      <tr>
                        <td align="center">
                          <mat-checkbox
                            [checked]="
                              userServiceUserDataValue
                                | hasUserStation
                                  : product
                                  : 'online'
                                  : areAllProductsSelectedValue
                            "
                            (change)="
                              onUserStationChange($event, product, 'online')
                            "></mat-checkbox>
                        </td>
                        <td>
                          {{ product['station']['overwriteStationName'] }}
                        </td>
                        <td>
                          @if (product['outOfSeason']) {
                            <fa-icon
                              [icon]="['far', 'times']"
                              style="color: red"></fa-icon>
                          } @else {
                            <fa-icon
                              [icon]="['far', 'check']"
                              style="color: green"></fa-icon>
                          }
                        </td>
                        <td>
                          {{ product['productData']['saison']['start']['day'] }}
                          .{{
                            product['productData']['saison']['start']['month']
                          }}. -
                          {{ product['productData']['saison']['end']['day'] }}
                          .{{
                            product['productData']['saison']['end']['month']
                          }}.
                        </td>
                      </tr>
                    }
                  </table>
                </mat-expansion-panel>
              }
            }
          </mat-accordion>
          <!--radar product-->
          @if (productListValue.radar.length > 0) {
            <div mat-subheader>
              <fa-icon [icon]="['far', 'umbrella']" size="lg"></fa-icon>
              &nbsp; {{ 'PRODUCT.RADAR.TITLE' | translate }}
            </div>
          }
          <mat-accordion
            #accordionRadarOnline="matAccordion"
            multi
            class="accordion-headers-align">
            @if (productListValue.radar.length > 0) {
              <mat-expansion-panel
                (expandedChange)="onExpandedChanged('online')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (
                      'online'
                        | hasUserProductType
                          : 'radar'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    ) {
                      <span>
                        <fa-icon
                          [icon]="['far', 'check']"
                          style="color: green"></fa-icon>
                      </span>
                    } @else {
                      <span>
                        <fa-icon
                          [icon]="['far', 'times']"
                          style="color: red"></fa-icon>
                      </span>
                    }
                    &nbsp;{{ 'PRODUCT.RADAR.TITLE' | translate }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{
                      'online'
                        | countUserProducts
                          : 'radar'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    }}
                    /
                    {{ productListValue.radar.length }}
                    {{ 'PRODUCT.USERADMIN.PRODUCTS.TITLE' | translate }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="product-detail-table" width="100%">
                  <tr>
                    <th align="center">
                      {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                    </th>
                    <th>{{ 'PRODUCT.USERADMIN.RADARREGION' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.RADARZOOM' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                  </tr>
                  @for (
                    product of productListValue.radar;
                    track $index;
                    let i = $index
                  ) {
                    <tr>
                      <td align="center">
                        <mat-checkbox
                          [checked]="
                            'online'
                              | hasUserProduct
                                : areAllProductsSelectedValue
                                : userServiceUserDataValue
                                : product['id']
                          "
                          (change)="
                            onUserProductChange($event, product, 'online')
                          "></mat-checkbox>
                      </td>
                      <td>
                        {{
                          'PRODUCT.RADAR.REGIONS.' + product['region']
                            | translate
                        }}
                      </td>
                      <td>
                        @for (
                          point of product['productData']['points'];
                          track $index
                        ) {
                          <span> {{ point['searchName'] }}<br /> </span>
                        }
                      </td>
                      <td>
                        @if (product['outOfSeason']) {
                          <fa-icon
                            [icon]="['far', 'times']"
                            style="color: red"></fa-icon>
                        } @else {
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        }
                      </td>
                      <td>
                        {{ product['productData']['saison']['start']['day'] }}
                        .{{
                          product['productData']['saison']['start']['month']
                        }}. -
                        {{ product['productData']['saison']['end']['day'] }}
                        .{{ product['productData']['saison']['end']['month'] }}.
                      </td>
                    </tr>
                  }
                </table>
              </mat-expansion-panel>
            }
          </mat-accordion>
          <!--marwis product-->
          @if (productListValue.marwis.length > 0) {
            <div mat-subheader>
              <fa-icon [icon]="['far', 'car']" size="lg"></fa-icon>
              &nbsp; {{ 'PRODUCT.MARWIS.TITLE' | translate }}
            </div>
          }
          <mat-accordion
            #accordionMarwisOnline="matAccordion"
            multi
            class="accordion-headers-align">
            @if (productListValue.marwis.length > 0) {
              <mat-expansion-panel
                (expandedChange)="onExpandedChanged('online')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (
                      'online'
                        | hasUserProductType
                          : 'marwis'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    ) {
                      <span>
                        <fa-icon
                          [icon]="['far', 'check']"
                          [ngStyle]="{ color: 'green' }"></fa-icon>
                      </span>
                    } @else {
                      <span>
                        <fa-icon
                          [icon]="['far', 'times']"
                          style="color: red"></fa-icon>
                      </span>
                    }
                    &nbsp;
                    {{ 'PRODUCT.MARWIS.TITLE' | translate }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{
                      'online'
                        | countUserProducts
                          : 'marwis'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    }}
                    /
                    {{ productListValue.marwis.length }}
                    {{ 'PRODUCT.USERADMIN.VEHICLES' | translate }}
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <table class="product-detail-table" width="100%">
                  <tr>
                    <th align="center">
                      {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                    </th>
                    <th>{{ 'PRODUCT.USERADMIN.VEHICLE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                  </tr>
                  @for (
                    product of productListValue.marwis;
                    track $index;
                    let i = $index
                  ) {
                    <tr>
                      <td align="center">
                        <mat-checkbox
                          [checked]="
                            userServiceUserDataValue
                              | hasUserStation
                                : product
                                : 'online'
                                : areAllProductsSelectedValue
                          "
                          (change)="
                            onUserStationChange($event, product, 'online')
                          "></mat-checkbox>
                      </td>
                      <td>{{ product['station']['overwriteStationName'] }}</td>
                      <td>
                        @if (product['outOfSeason']) {
                          <fa-icon
                            [icon]="['far', 'times']"
                            style="color: red"></fa-icon>
                        } @else {
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        }
                      </td>
                      <td>
                        {{ product['productData']['saison']['start']['day'] }}
                        .{{
                          product['productData']['saison']['start']['month']
                        }}. -
                        {{ product['productData']['saison']['end']['day'] }}
                        .{{ product['productData']['saison']['end']['month'] }}.
                      </td>
                    </tr>
                  }
                </table>
              </mat-expansion-panel>
            }
          </mat-accordion>
          <!--route product-->
          @if (productListValue.route.length > 0) {
            <div mat-subheader>
              <fa-icon [icon]="['far', 'road']" size="lg"></fa-icon>
              &nbsp; {{ 'PRODUCT.ROUTENPROGNOSE.TITLE' | translate }}
            </div>
          }
          <mat-accordion
            #accordionRouteOnline="matAccordion"
            multi
            class="accordion-headers-align">
            @if (productListValue.route.length > 0) {
              <mat-expansion-panel
                (expandedChange)="onExpandedChanged('online')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (
                      'online'
                        | hasUserProductType
                          : 'route'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    ) {
                      <span>
                        <fa-icon
                          [icon]="['far', 'check']"
                          style="color: green"></fa-icon>
                      </span>
                    } @else {
                      <span>
                        <fa-icon
                          [icon]="['far', 'times']"
                          style="color: red"></fa-icon>
                      </span>
                    }
                    &nbsp;{{ 'PRODUCT.ROUTENPROGNOSE.TITLE' | translate }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{
                      'online'
                        | countUserProducts
                          : 'route'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    }}
                    /
                    {{ productListValue.route.length }}
                    {{ 'PRODUCT.USERADMIN.PRODUCTS.TITLE' | translate }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="product-detail-table" width="100%">
                  <tr>
                    <th align="center">
                      {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                    </th>
                    <th>Route</th>
                    <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                  </tr>
                  @for (
                    product of productListValue.route;
                    track $index;
                    let i = $index
                  ) {
                    <tr>
                      <td align="center">
                        <mat-checkbox
                          [checked]="
                            'online'
                              | hasUserProduct
                                : areAllProductsSelectedValue
                                : userServiceUserDataValue
                                : product['id']
                          "
                          (change)="
                            onUserProductChange($event, product, 'online')
                          "></mat-checkbox>
                      </td>
                      <td>
                        @for (
                          point of product['productData']['points'];
                          track $index
                        ) {
                          <span> {{ point['searchName'] }}<br /> </span>
                        }
                      </td>
                      <td>
                        @if (product['outOfSeason']) {
                          <fa-icon
                            [icon]="['far', 'times']"
                            style="color: red"></fa-icon>
                        } @else {
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        }
                      </td>
                      <td>
                        {{ product['productData']['saison']['start']['day'] }}
                        .{{
                          product['productData']['saison']['start']['month']
                        }}. -
                        {{ product['productData']['saison']['end']['day'] }}
                        .{{ product['productData']['saison']['end']['month'] }}.
                      </td>
                    </tr>
                  }
                </table>
              </mat-expansion-panel>
            }
          </mat-accordion>
          <!--pigeon product-->
          @if (productListValue.tauben.length > 0) {
            <div mat-subheader>
              <fa-icon [icon]="['far', 'road']" size="lg"></fa-icon>
              &nbsp; {{ 'PRODUCT.PIGEONS.TITLE' | translate }}
            </div>
          }
          <mat-accordion
            #accordionTaubenOnline="matAccordion"
            multi
            class="accordion-headers-align">
            @if (productListValue.tauben.length > 0) {
              <mat-expansion-panel
                (expandedChange)="onExpandedChanged('online')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (
                      'online'
                        | hasUserProductType
                          : 'tauben'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    ) {
                      <span>
                        <fa-icon
                          [icon]="['far', 'check']"
                          style="color: green"></fa-icon>
                      </span>
                    }
                    @if (
                      !(
                        'online'
                        | hasUserProductType
                          : 'route'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                      )
                    ) {
                      <span>
                        <fa-icon
                          [icon]="['far', 'times']"
                          style="color: red"></fa-icon>
                      </span>
                    }
                    &nbsp;{{ 'PRODUCT.PIGEONS.TITLE' | translate }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{
                      'online'
                        | countUserProducts
                          : 'tauben'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    }}
                    /
                    {{ productListValue.tauben.length }}
                    {{ 'PRODUCT.USERADMIN.PRODUCTS.TITLE' | translate }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="product-detail-table" width="100%">
                  <tr>
                    <th align="center">
                      {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                    </th>
                    <th>Orte</th>
                    <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                  </tr>
                  @for (
                    product of productListValue.tauben;
                    track $index;
                    let i = $index
                  ) {
                    <tr>
                      <td align="center">
                        <mat-checkbox
                          [checked]="
                            'online'
                              | hasUserProduct
                                : areAllProductsSelectedValue
                                : userServiceUserDataValue
                                : product['id']
                          "
                          (change)="
                            onUserProductChange($event, product, 'online')
                          "></mat-checkbox>
                      </td>
                      <td>
                        @for (
                          point of product['productData']['points'];
                          track $index
                        ) {
                          <span> {{ point['searchName'] }}<br /> </span>
                        }
                      </td>
                      <td>
                        @if (product['outOfSeason']) {
                          <fa-icon
                            [icon]="['far', 'times']"
                            style="color: red"></fa-icon>
                        } @else {
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        }
                      </td>
                      <td>
                        {{ product['productData']['saison']['start']['day'] }}
                        .{{
                          product['productData']['saison']['start']['month']
                        }}. -
                        {{ product['productData']['saison']['end']['day'] }}
                        .{{ product['productData']['saison']['end']['month'] }}.
                      </td>
                    </tr>
                  }
                </table>
              </mat-expansion-panel>
            }
          </mat-accordion>
          <!--gsa product-->
          @if (productListValue.ampel.length > 0) {
            <div mat-subheader>
              <fa-icon [icon]="['far', 'traffic-light']" size="lg"></fa-icon>
              &nbsp; {{ 'PRODUCT.AMPEL.TITLE' | translate }}
            </div>
          }
          <mat-accordion
            #accordionAmpelOnline="matAccordion"
            multi
            class="accordion-headers-align">
            @if (productListValue.ampel.length > 0) {
              <mat-expansion-panel
                (expandedChange)="onExpandedChanged('online')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (
                      'online'
                        | hasUserProductType
                          : 'ampel'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    ) {
                      <span>
                        <fa-icon
                          [icon]="['far', 'check']"
                          style="color: green"></fa-icon>
                      </span>
                    } @else {
                      <span>
                        <fa-icon
                          [icon]="['far', 'times']"
                          style="color: red"></fa-icon>
                      </span>
                    }
                    &nbsp;{{ 'PRODUCT.AMPEL.TITLE' | translate }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{
                      'online'
                        | countUserProducts
                          : 'ampel'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    }}
                    /
                    {{ productListValue.ampel.length }}
                    {{ 'PRODUCT.USERADMIN.PRODUCTS.TITLE' | translate }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="product-detail-table" width="100%">
                  <tr>
                    <th align="center">
                      {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                    </th>
                    <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                  </tr>
                  @for (
                    product of productListValue.ampel;
                    track $index;
                    let i = $index
                  ) {
                    <tr>
                      <td align="center">
                        <mat-checkbox
                          [checked]="
                            'online'
                              | hasUserProduct
                                : areAllProductsSelectedValue
                                : userServiceUserDataValue
                                : product['id']
                          "
                          (change)="
                            onUserProductChange($event, product, 'online')
                          "></mat-checkbox>
                      </td>
                      <td>
                        @if (product['outOfSeason']) {
                          <fa-icon
                            [icon]="['far', 'times']"
                            style="color: red"></fa-icon>
                        } @else {
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        }
                      </td>
                      <td>
                        {{ product['productData']['saison']['start']['day'] }}
                        .{{
                          product['productData']['saison']['start']['month']
                        }}. -
                        {{ product['productData']['saison']['end']['day'] }}
                        .{{ product['productData']['saison']['end']['month'] }}.
                      </td>
                    </tr>
                  }
                </table>
              </mat-expansion-panel>
            }
          </mat-accordion>

          <!-- TREND-->
          @if (productListValue.trend.length > 0) {
            <div mat-subheader>
              <fa-icon [icon]="['far', 'telescope']" size="lg"></fa-icon>
              &nbsp; {{ 'PRODUCT.TREND.TITLE' | translate }}
            </div>
          }
          <mat-accordion
            #accordionTrendOnline="matAccordion"
            multi
            class="accordion-headers-align">
            @if (productListValue.trend.length > 0) {
              <mat-expansion-panel
                (expandedChange)="onExpandedChanged('online')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (
                      'online'
                        | hasUserProductType
                          : 'trend'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    ) {
                      <span>
                        <fa-icon
                          [icon]="['far', 'check']"
                          style="color: green"></fa-icon>
                      </span>
                    } @else {
                      <span>
                        <fa-icon
                          [icon]="['far', 'times']"
                          style="color: red"></fa-icon>
                      </span>
                    }
                    &nbsp;{{ 'PRODUCT.TREND.TITLE' | translate }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{
                      'online'
                        | countUserProducts
                          : 'trend'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    }}
                    /
                    {{ productListValue.trend.length }}
                    {{ 'PRODUCT.USERADMIN.PRODUCTS.TITLE' | translate }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="product-detail-table" width="100%">
                  <tr>
                    <th align="center">
                      {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                    </th>
                    <th>Region</th>
                    <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                  </tr>
                  @for (
                    product of productListValue.trend;
                    track $index;
                    let i = $index
                  ) {
                    <tr>
                      <td align="center">
                        <mat-checkbox
                          [checked]="
                            'online'
                              | hasUserProduct
                                : areAllProductsSelectedValue
                                : userServiceUserDataValue
                                : product['id']
                          "
                          (change)="
                            onUserProductChange($event, product, 'online')
                          "></mat-checkbox>
                      </td>
                      <td>{{ product.area }}</td>
                      <td>
                        @if (product['outOfSeason']) {
                          <fa-icon
                            [icon]="['far', 'times']"
                            style="color: red"></fa-icon>
                        } @else {
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        }
                      </td>
                      <td>
                        {{ product['productData']['saison']['start']['day'] }}
                        .{{
                          product['productData']['saison']['start']['month']
                        }}. -
                        {{ product['productData']['saison']['end']['day'] }}
                        .{{ product['productData']['saison']['end']['month'] }}.
                      </td>
                    </tr>
                  }
                </table>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </mat-list>
      }
    </mat-card>
  }
  <!--button panel-->
  <div class="button-row">
    <button
      mat-raised-button
      class="btn-app-cancel"
      type="button"
      (click)="onCancel()">
      {{ 'PRODUCT.USERADMIN.CANCEL' | translate }}
    </button>
    &nbsp;
    <button mat-raised-button class="btn-app-back" matStepperPrevious>
      {{ 'PRODUCT.USERADMIN.BACK' | translate }}
    </button>
    &nbsp;
    <button mat-raised-button class="btn-app-next" matStepperNext>
      {{ 'PRODUCT.USERADMIN.NEXT' | translate }}</button
    >&nbsp;
    @if (!newUser()) {
      <button
        [disabled]="isSaving() || userService.loadingUserList()"
        mat-raised-button
        class="btn-app-save"
        (click)="onSummarizeUser()">
        {{ 'PRODUCT.USERADMIN.SAVE' | translate }}
      </button>
    }
  </div>
</form>
